import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  AdPlacementRoadOccupationForm,
  AdPlacementRoadOccupationFormValue
} from '../../forms/ad-placement-road-occupation.form';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import {
  LocationDecisionsCrudComponent
} from '../../../../../common/components/location-decisions/location-decisions-crud/location-decisions-crud.component';
import { TabViewComponent } from '../../../../../../../../common/tab-view/tab-view.component';
import { TabPanelComponent } from '../../../../../../../../common/tab-view/tab-panel.component';
import { AdPlacementStageFormComponent } from '../ad-placement-stage-form/ad-placement-stage-form.component';

@Component({
  selector: 'app-ad-placement-road-occupation-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    LocationDecisionsCrudComponent,
    TabViewComponent,
    TabPanelComponent,
    AdPlacementStageFormComponent
  ],
  templateUrl: './ad-placement-road-occupation-form.component.html'
})
export class AdPlacementRoadOccupationFormComponent {

  @Input()
  public edit: boolean = false;

  @Input()
  public showCancel: boolean = true;

  @Input()
  public form: AdPlacementRoadOccupationForm | undefined;

  @Output()
  public onSubmit = new EventEmitter<AdPlacementRoadOccupationFormValue>();

  @Output()
  public onCancel = new EventEmitter();

  public submit(): void {
    if (this.form?.valid) {
      this.onSubmit.emit(this.form.values);
      this.form.reset();
    } else {
      this.form?.markAllAsTouched();
    }
  }

  public cancel(): void {
    this.onCancel.emit();
    this.form?.reset();
  }

}
